import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, DateTime } from 'ionic-angular';
import { VehicleProvider} from '../../providers/vehicle/vehicle';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-vehicle-access-log',
  templateUrl: 'vehicle-access-log.html',
})
export class VehicleAccessLogPage {

  currentEvents = [];
  selectedLog = [];
  showData = false;
  summary: any;
  viewTitle="";
  selectedDate= new Date();
  id=null;
  vehicleNo = null;

  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    public vehicleProvider : VehicleProvider,
    private ref: ChangeDetectorRef) {
    let today = new Date();
    this.id= navParams.get("id");
    this.vehicleNo = navParams.get("vehicleNo");
    vehicleProvider.vehicleLogs(this.id, new Date(today.getFullYear(), today.getMonth(), 1).toISOString().slice(0,10) ,new Date().toISOString().slice(0,10), true ).then(val => {
      if(val.status == "success"){
        this.generateData(val.data);
        this.summary = val.metadata;
        this.showData = true;
      }
    });
  }
  
  generateData(data: any[]){
    this.currentEvents = [];
    data.forEach(val => {
      let event = {
        status: val.status,
        year: val.date_time.slice(0,4),
        month: val.date_time.slice(5,7)-1,
        date: val.date_time.slice(8,10),
        date_time: val.date_time,
      }
      this.currentEvents.push(event);
    });
    return this.selectedLog = this.currentEvents;
  }
  onDaySelect(event){
    this.selectedLog = [];
    let date_time = new Date(event.year, event.month, event.date);
    this.selectedDate = date_time;
    if(event.hasEvent){
      this.currentEvents.forEach(val => {
        let temp = new Date(this.convertDate(val.date_time));
        temp.setHours(0,0,0,0);
        if(temp.valueOf() == date_time.valueOf()){
          this.selectedLog.push(val);
        }
      });
      this.ref.detectChanges();
    }
  }
  convertDate(value: string){
    if(value && typeof value == 'string'){
      return value.replace(/-/g, "/");
    }else{
      return value;
    }
  }
  onMonthSelect(event){
    let firstDate = new Date(event.year, event.month, 1+1).toISOString().slice(0,10);
    let lastDate = new Date(event.year, event.month+1, 1).toISOString().slice(0,10);  
    this.vehicleProvider.vehicleLogs(this.navParams.get("id"), firstDate , lastDate, true).then(val => {
      if(val.status == "success"){
        this.generateData(val.data);
        this.summary = val.metadata;
        this.showData = true;
      }
    });
  }
  getDaysInMonth = function(month,year) {
    return new Date(year, month, 0).getDate();
  };
  showAll(){
    this.selectedLog = this.currentEvents;
  }
  ionViewDidLoad() {
    console.log('ionViewDidLoad VehicleAccessLogPage');
  }
}


// WEBPACK FOOTER //
// ./src/pages/vehicle-access-log/vehicle-access-log.ts